// extracted by mini-css-extract-plugin
module.exports = {"container":"form-error_container__1JWAL","icon":"form-error_icon__1FENJ"};